import { 
  Tractor, Car, Cpu, FlaskConical, Building, 
  Lightbulb, Cog, Stethoscope, Factory,
  Package, FileText, Pill, Layers, Shield, 
  Radio, Scissors, Utensils,
  Leaf, Pickaxe, LucideIcon
} from 'lucide-react';

export interface CategoryData {
  name: string;
  icon: LucideIcon;
  subcategories: string[];
}

export const categoriesData: CategoryData[] = [
  {
    name: 'Agriculture Equipment & Supplies',
    icon: Tractor,
    subcategories: [
      'Agricultural Machinery',
      'Irrigation Equipment',
      'Seeds & Plants',
      'Fertilizers & Pesticides',
      'Farm Tools & Equipment',
      'Animal Feed',
      'Greenhouse Equipment',
      'Harvesting Equipment',
      'Storage & Silos',
      'Dairy Equipment',
      'Agricultural Spades',
      'Garden Spades',
      'Trenching Spades',
      'Agricultural Shovels',
      'Scoop Shovels',
      'Agricultural Forks',
      'Digging Forks',
      'Manure Forks',
      'Agricultural Hoes',
      'Garden Hoes',
      'Weeding Hoes',
      'Agricultural Rakes',
      'Cane Knives',
      'Sugarcane Tools',
      'Plantation Tools',
    ]
  },
  {
    name: 'Auto Vehicle & Accessories',
    icon: Car,
    subcategories: [
      'Car Parts',
      'Truck Parts',
      'Motorcycle Parts',
      'Auto Batteries',
      'Tires & Wheels',
      'Auto Electronics',
      'Body Parts',
      'Engine Components',
      'Lubricants & Oils',
      'Interior Accessories',
    ]
  },
  {
    name: 'Building & Construction',
    icon: Building,
    subcategories: [
      'Cement & Concrete',
      'Tiles & Flooring',
      'Sanitary Ware',
      'Doors & Windows',
      'Roofing Materials',
      'Paints & Coatings',
      'Plumbing Supplies',
      'Electrical Fittings',
      'Glass & Glazing',
      'GC Roofing Sheets',
      'GP Roofing Sheets',
      'Color Coated Roofing Sheets',
      'Metal Roofing',
      'Galvanized Roofing',
      'Pre-Painted Roofing Sheets',
      'C Purlins',
      'Z Purlins',
      'Monopoles',
      'Transmission Poles',
      'Telecom Monopoles',
      'Tata Wiron Products',
    ]
  },
  {
    name: 'Chemicals & Raw Materials',
    icon: FlaskConical,
    subcategories: [
      'Industrial Chemicals',
      'Lab Chemicals',
      'Dyes & Pigments',
      'Solvents',
      'Adhesives & Sealants',
      'Petrochemicals',
      'Agrochemicals',
      'Specialty Chemicals',
      'Water Treatment Coagulants',
      'Flocculants',
      'Water Disinfectants',
      'Biocides',
      'Antiscalants',
      'Corrosion Inhibitors',
      'pH Adjusters',
      'Water Treatment Dispersants',
      'Anionic Surfactants',
      'Nonionic Surfactants',
      'Amphoteric Surfactants',
      'Cationic Surfactants',
      'Chelating Agents',
      'Industrial Preservatives',
      'Silicone Surfactants',
      'Fine Chemicals',
      'Electronic Chemicals',
      'Textile Chemicals',
      'Leather Chemicals',
      'Rubber Additives',
      'Plastic Additives',
      'Foaming Agents',
      'Refrigerants',
      'Paint Resins',
      'Coating Additives',
      'Paint Solvents',
      'Pigment Dispersants',
      'Anti-Foaming Agents',
      'Thickeners',
      'Wetting Agents',
    ]
  },
  {
    name: 'Electrical Equipment & Supplies',
    icon: Lightbulb,
    subcategories: [
      'Wires & Cables',
      'Switches & Sockets',
      'Circuit Breakers',
      'Transformers',
      'Motors & Drives',
      'Control Panels',
      'Power Distribution',
    ]
  },
  {
    name: 'Electronic Components',
    icon: Cpu,
    subcategories: [
      'Semiconductors',
      'Capacitors',
      'Resistors',
      'PCBs',
      'Connectors',
      'LEDs',
      'Sensors',
      'Integrated Circuits',
    ]
  },
  {
    name: 'Energy & Power',
    icon: Lightbulb,
    subcategories: [
      'Solar Equipment',
      'Wind Energy',
      'Generators',
      'Batteries & UPS',
      'Power Cables',
      'Energy Storage',
      'Grid Equipment',
      'Energy Meters',
    ]
  },
  {
    name: 'Environment & Recycling',
    icon: Leaf,
    subcategories: [
      'Waste Management',
      'Recycling Equipment',
      'Water Treatment',
      'Air Purification',
      'Eco-friendly Products',
      'Pollution Control',
      'Composting Systems',
    ]
  },
  {
    name: 'Food & Beverages',
    icon: Utensils,
    subcategories: [
      'Grains & Cereals',
      'Spices & Herbs',
      'Oils & Fats',
      'Dairy Products',
      'Beverages',
      'Processed Foods',
      'Frozen Foods',
      'Organic Foods',
      'Snacks & Confectionery',
      'Food Preservatives',
      'Food Emulsifiers',
      'Food Colorants',
      'Sweeteners',
      'Flavor Enhancers',
      'Thickening Agents',
      'Stabilizers',
      'Acidulants',
      'Antioxidants',
      'Nutraceuticals',
      'Dietary Supplements',
      'Protein Ingredients',
      'Vitamins & Minerals',
      'Probiotics & Prebiotics',
      'Sports Nutrition',
    ]
  },
  {
    name: 'Flavors & Fragrances',
    icon: FlaskConical,
    subcategories: [
      'Natural Flavors',
      'Synthetic Flavors',
      'Fruit Flavors',
      'Dairy Flavors',
      'Savory Flavors',
      'Beverage Flavors',
      'Confectionery Flavors',
      'Mint & Menthol',
      'Vanilla & Vanillin',
      'Citrus Flavors',
      'Fine Fragrances',
      'Functional Fragrances',
      'Aroma Chemicals',
      'Fragrance Oils',
      'Musk Compounds',
      'Floral Notes',
      'Woody Notes',
    ]
  },
  {
    name: 'Hardware & Tools',
    icon: Cog,
    subcategories: [
      'Hand Tools',
      'Power Tools',
      'Fasteners',
      'Locks & Security',
      'Garden Tools',
      'Measuring Tools',
      'Abrasives',
      'Tool Storage',
      'Spades & Shovels',
      'D-Handle Spades',
      'Square Mouth Shovels',
      'Round Mouth Shovels',
      'Post Hole Diggers',
      'Crowbars & Pinch Bars',
      'Pickaxes & Mattocks',
      'Hammers',
      'Axes & Hatchets',
      'Chisels',
      'Files & Rasps',
      'Pliers & Cutters',
      'Wrenches & Spanners',
      'Screwdrivers',
      'Masonry Tools',
      'Plastering Trowels',
      'Brick Trowels',
      'Pointing Trowels',
      'Floats',
      'Mason Hammers',
      'Tile Cutters',
      'Concrete Tools',
      'Leveling Tools',
      'Bolts & Nuts',
      'Washers',
      'Screws',
      'Anchors',
      'Rivets',
      'Nails & Pins',
      'Hooks & Hangers',
      'Hinges',
      'Hasps & Staples',
      'Wire Rope & Chains',
    ]
  },
  {
    name: 'Medical & Healthcare',
    icon: Stethoscope,
    subcategories: [
      'Medical Equipment',
      'Medical Supplies',
      'Surgical Instruments',
      'Hospital Furniture',
      'Lab Equipment',
      'Diagnostic Equipment',
      'Diagnostic Devices',
      'Rehabilitation Equipment',
      'Rehabilitation Aids',
      'Dental Equipment',
      'Veterinary Equipment',
      'Health Supplements',
      'First Aid',
      'Wellness Products',
      'Therapeutic Equipment',
    ]
  },
  {
    name: 'Industrial Supplies',
    icon: Factory,
    subcategories: [
      'Industrial Tools',
      'Safety Equipment',
      'Material Handling',
      'Pumps & Valves',
      'Bearings & Seals',
      'Industrial Hoses',
      'Cleaning Supplies',
      'Packaging Materials',
    ]
  },
  {
    name: 'Metals - Ferrous (Steel, Iron)',
    icon: Layers,
    subcategories: [
      'Pig Iron',
      'Basic Pig Iron',
      'Foundry Grade Pig Iron',
      'CR Sheet',
      'CR Coil',
      'Cold Rolled GP Sheets',
      'Cold Rolled Annealed Coils',
      'Full Hard Cold Rolled Coils',
      'HR Coil',
      'HR Sheet',
      'HR Plates',
      'Hot Rolled Pickled & Oiled (HRPO)',
      'Chequered Plates',
      'Galvanised Plain (GP) Sheets',
      'Galvanised Corrugated (GC) Sheets',
      'Galvanised Coils',
      'Color Coated Sheets',
      'Steel Pipes',
      'ERW Pipes',
      'Spiral Welded Pipes',
      'Seamless Pipes',
      'API Grade Pipes',
      'Billets',
      'Blooms',
      'Slabs',
      'Ingots',
      'Structural Steel',
      'Angles',
      'Channels',
      'Beams (ISMB/ISJB/ISLB)',
      'Joists',
      'H-Beams',
      'I-Beams',
      'TMT Bar',
      'TMT Bars Fe-500',
      'TMT Bars Fe-500D',
      'TMT Bars Fe-550',
      'TMT Bars Fe-550D',
      'TMT Bars Fe-600',
      'SeQR TMT Bars',
      'Earthquake Resistant TMT',
      'Wire Rods',
      'High Carbon Wire Rods',
      'Low Carbon Wire Rods',
      'Electrode Quality Wire Rods',
      'Cold Heading Quality Wire Rods',
      'PM Plates',
      'Boiler Quality Plates',
      'Shipbuilding Plates',
      'Structural Plates',
      'Pressure Vessel Plates',
      'High Tensile Plates',
      'Wear Resistant Plates',
      'Rails',
      'Crane Rails',
      'Fish Plates',
      'Railway Track Components',
      '60 Kg Rails',
      '52 Kg Rails',
      'Head Hardened Rails',
      'Railway Wheels',
      'Railway Axles',
      'Wheel Sets',
      'Forged Wheels',
      'Stainless Steel Sheets',
      'Stainless Steel Coils',
      'Stainless Steel Plates',
      'Stainless Steel Bars',
      'Austenitic Stainless Steel',
      'Ferritic Stainless Steel',
      'Duplex Stainless Steel',
      'Electrical Steel Sheets',
      'CRGO (Cold Rolled Grain Oriented)',
      'CRNGO (Cold Rolled Non-Grain Oriented)',
      'Silicon Steel',
      'Transformer Grade Steel',
      'Motor Grade Steel',
      'Steel Sheets',
      'Steel Bars & Rods',
      'Iron Castings',
      'Alloy Steel',
      'Tool Steel',
      'Scrap',
      'Iron Ore',
      'HT Strands',
      'LRPC (Low Relaxation Prestressed Concrete Strand)',
      'PC Strand',
      'Prestressing Steel',
    ]
  },
  {
    name: 'Metals - Non-Ferrous (Copper, Aluminium)',
    icon: Layers,
    subcategories: [
      'Copper Products',
      'Aluminum Products',
      'Brass Products',
      'Zinc Products',
      'Lead Products',
      'Nickel Alloys',
      'Titanium Products',
      'Bronze Products',
      'Aluminium Ingots',
      'Aluminium Billets',
      'Copper Cathodes',
      'Copper Wire Rods',
      'Zinc Ingots',
      'Lead Ingots',
      'Tin Ingots',
      'Aluminium Sheets',
      'Aluminium Coils',
      'Copper Sheets',
      'Brass Sheets',
      'Aluminium Scrap',
      'Copper Scrap',
      'Brass Scrap',
    ]
  },
  {
    name: 'Mining & Minerals',
    icon: Pickaxe,
    subcategories: [
      'Coal & Coke',
      'Limestone',
      'Marble & Granite',
      'Sand & Gravel',
      'Precious Metals',
      'Industrial Minerals',
      'Mining Equipment',
    ]
  },
  {
    name: 'Packaging & Printing',
    icon: Package,
    subcategories: [
      'Corrugated Boxes',
      'Plastic Packaging',
      'Labels & Tags',
      'Printing Services',
      'Flexible Packaging',
      'Glass Packaging',
      'Promotional Printing',
    ]
  },
  {
    name: 'Paper & Paper Products',
    icon: FileText,
    subcategories: [
      'Printing Paper',
      'Packaging Paper',
      'Tissue Paper',
      'Specialty Paper',
      'Paper Boards',
      'Notebooks & Diaries',
      'Paper Bags',
      'Recycled Paper',
    ]
  },
  {
    name: 'Pharmaceuticals & Drugs',
    icon: Pill,
    subcategories: [
      'Generic Medicines',
      'API (Active Pharmaceutical Ingredients)',
      'Formulations',
      'Herbal Medicines',
      'Veterinary Drugs',
      'OTC Products',
      'Pharmaceutical Packaging',
      'Medical Devices',
      'Analgesic Intermediates',
      'Anesthetic Intermediates',
      'Antibacterial Intermediates',
      'Anticancer Intermediates',
      'Antiviral Intermediates',
      'Cardiovascular Intermediates',
      'Diabetes Drug Intermediates',
      'CNS Drug Intermediates',
      'Anti-Inflammatory Intermediates',
      'Immunosuppressant Intermediates',
      'Excipients',
      'Pharmaceutical Solvents',
      'Pharmaceutical Catalysts',
      'Chiral Compounds',
      'Amino Acids',
      'Vitamins & Derivatives',
      'Nucleosides & Nucleotides',
    ]
  },
  {
    name: 'Plastic & Rubber',
    icon: Layers,
    subcategories: [
      'Plastic Raw Materials',
      'Plastic Products',
      'Rubber Products',
      'Plastic Machinery',
      'Recycled Plastics',
      'Industrial Rubber',
      'Foam Products',
      'Polymer Products',
    ]
  },
  {
    name: 'GFRP & Composites',
    icon: Layers,
    subcategories: [
      'GFRP Sheets',
      'GFRP Pipes',
      'GFRP Gratings',
      'GFRP Profiles',
      'GFRP Tanks',
      'FRP Rebar',
      'GFRP Panels',
      'Composite Raw Materials',
      'GFRP Structural Components',
      'Carbon Fiber Products',
      'GFRP Manhole Covers',
      'GFRP Cable Trays',
      'GFRP Ladders',
    ]
  },
  {
    name: 'Polymers & Resins',
    icon: Layers,
    subcategories: [
      'Polyethylene (PE)',
      'Polypropylene (PP)',
      'PVC Resins',
      'ABS Resins',
      'Polyester Resins',
      'Epoxy Resins',
      'Polyurethane',
      'Nylon & Polyamide',
      'Polycarbonate',
      'Engineering Plastics',
      'HDPE Granules',
      'LDPE Granules',
      'LLDPE Granules',
      'PVC Compounds',
      'PP Homopolymer',
      'PP Copolymer',
      'PET Resins',
      'PS (Polystyrene)',
      'EVA Copolymer',
      'Color Masterbatch',
      'Additive Masterbatch',
      'Filler Masterbatch',
    ]
  },
  {
    name: 'Pipes & Tubes',
    icon: Cog,
    subcategories: [
      'LSAW Pipes',
      'HSAW Pipes',
      'Poles',
      'DI Pipes',
      'HDPE Pipes',
      'PVC Pipes',
      'GI Pipes',
      'MS Pipes',
      'Copper Tubes',
      'Stainless Steel Pipes',
      'Structural Steel Tubes',
      'Hollow Sections',
      'Square Hollow Sections (SHS)',
      'Rectangular Hollow Sections (RHS)',
      'Circular Hollow Sections (CHS)',
      'Precision Tubes',
      'Cold Drawn Tubes',
      'Boiler Tubes',
      'Heat Exchanger Tubes',
      'Hydraulic Tubes',
      'Automotive Tubes',
      'Furniture Tubes',
      'Scaffolding Tubes',
      'Conveyor Tubes',
      'Line Pipes',
      'Casing Pipes',
      'API Pipes',
      'Water Well Casing',
      'Galvanized Steel Pipes',
      'Pre-Galvanized Pipes',
      'Black Steel Pipes',
      'Ductile Iron Pipes',
      'DI Fittings',
      'Centrifugal Cast DI Pipes',
      'Push-on Joint Pipes',
      'Flanged DI Pipes',
      'Restrained Joint Pipes',
    ]
  },
  {
    name: 'Solar & Renewable Energy',
    icon: Lightbulb,
    subcategories: [
      'Solar Panels',
      'Solar Inverters',
      'Solar Batteries',
      'Solar Mounting Systems',
      'Solar Water Heaters',
      'Solar Street Lights',
      'Solar Pumps',
      'Solar Cables & Connectors',
      'Charge Controllers',
      'Off-Grid Systems',
    ]
  },
  {
    name: 'Petroleum & Bitumen',
    icon: Factory,
    subcategories: [
      'Diesel',
      'Bitumen',
      'Furnace Oil',
      'Light Diesel Oil (LDO)',
      'High Speed Diesel (HSD)',
      'Lubricants',
      'Base Oil',
      'Petroleum Coke',
      'Asphalt',
      'Crude Oil',
      'Bitumen VG10',
      'Bitumen VG30',
      'Bitumen VG40',
      'Emulsion Bitumen',
      'Polymer Modified Bitumen',
      'Cutback Bitumen',
      'Natural Gas',
      'LPG Industrial',
      'Methanol',
      'Ethanol',
      'Coal Tar',
      'Naptha',
    ]
  },
  {
    name: 'Safety & Security',
    icon: Shield,
    subcategories: [
      'Personal Protective Equipment',
      'CCTV & Surveillance',
      'Access Control',
      'Fire Safety',
      'Alarms & Sensors',
      'Security Systems',
      'Safety Signs',
      'Traffic Safety',
    ]
  },
  {
    name: 'Telecommunication',
    icon: Radio,
    subcategories: [
      'Telecom Equipment',
      'Network Infrastructure',
      'Fiber Optics',
      'Antennas',
      'Communication Devices',
      'Broadcasting Equipment',
      'Satellite Equipment',
      'VoIP Solutions',
    ]
  },
  {
    name: 'Textiles & Leather',
    icon: Scissors,
    subcategories: [
      'Fabrics',
      'Yarns & Threads',
      'Home Textiles',
      'Technical Textiles',
      'Leather Products',
      'Leather Raw Materials',
      'Garment Accessories',
    ]
  },
  {
    name: 'Industrial Storage & Tanks',
    icon: Factory,
    subcategories: [
      'Industrial Storage Tanks',
      'Effluent Treatment Storage Tanks',
      'Glass Lined Tanks',
      'Corrugated Steel Tanks',
      'GFS Storage Tanks',
      'Zinc Aluminium Tanks',
      'Zincalume Steel Tanks',
      'Industrial Silos',
      'Flat Bottom Silos',
      'Grain Storage Silos',
      'Hopper Bottom Silos',
      'Bucket Elevators',
      'Industrial Conveyors',
      'Belt Conveyors',
      'Chain Conveyors',
      'Roller Conveyors',
      'Water Storage Tanks',
      'SS Tanks',
      'Liquid Tanks',
      'Fire Water Tanks',
      'Sewage Treatment Tanks',
      'Bio Digester Tanks',
      'Bolted Steel Tanks',
    ]
  },
  {
    name: 'Steel Fabrication & Structures',
    icon: Cog,
    subcategories: [
      'MS Structures',
      'Steel Ducting',
      'Profiled Sheets',
      'Perforated Sheets',
      'Cable Trays',
      'Steel Gratings',
      'Handrails & Railings',
      'Overhead Walkways',
      'Nozzles & Flanges',
      'Steel Platforms',
      'Structural Steel Fabrication',
      'Industrial Ladders',
      'Steel Staircases',
      'Support Structures',
    ]
  },
  {
    name: 'Road Safety & Infrastructure',
    icon: Shield,
    subcategories: [
      'Crash Barriers',
      'Metal Crash Barriers',
      'W-Beam Crash Barriers',
      'Thrie Beam Crash Barriers',
      'Box Beam Crash Barriers',
      'Cable Barriers',
      'Concrete Barriers',
      'Bridge Barriers',
      'Median Barriers',
      'Guardrails',
      'End Terminals',
      'Crash Cushions',
      'Road Studs',
      'Cat Eyes',
      'Reflective Road Markers',
      'Delineators',
      'Traffic Cones',
      'Speed Breakers',
      'Rumble Strips',
      'Bollards',
      'Parking Barriers',
      'Traffic Signs',
      'Highway Signs',
      'Reflective Signs',
      'LED Traffic Signs',
      'Warning Signs',
      'Directional Signs',
      'Thermoplastic Road Marking',
      'Road Paint',
      'Lane Marking',
      'Zebra Crossing Materials',
      'Street Light Poles',
      'Highway Lighting',
      'Toll Plaza Equipment',
      'Road Dividers',
      'Kerb Stones',
      'Drainage Systems',
    ]
  },
  // ============================================================
  // PHASE-3 CATEGORIES (Non-overlapping with metals/infra)
  // ============================================================
  {
    name: 'Industrial Consumables',
    icon: Cog,
    subcategories: [
      'Industrial Lubricants & Oils',
      'Bearings, Seals & Gaskets',
      'Welding Consumables',
      'Adhesives & Sealants',
      'Safety Equipment & PPE',
      'Cutting Tools & Abrasives',
      'Industrial Tapes',
      'Cleaning Chemicals',
      'Greases & Compounds',
      'Hydraulic Fluids',
    ]
  },
  {
    name: 'Export-Driven Machinery',
    icon: Factory,
    subcategories: [
      'Packaging Machinery',
      'Plastic Processing Machinery',
      'Printing & Labeling Equipment',
      'Textile Processing Machinery',
      'Cold Storage & Refrigeration Systems',
      'Food Processing Machinery',
      'Pharmaceutical Machinery',
      'Filling & Sealing Machines',
      'Injection Molding Machines',
      'Extrusion Machinery',
    ]
  },
  {
    name: 'Compliance & Automation',
    icon: Shield,
    subcategories: [
      'Fire Safety Systems',
      'Environmental Monitoring Equipment',
      'Industrial Automation & Sensors',
      'Laboratory Testing Equipment',
      'Quality Inspection Machines',
      'PLC & SCADA Systems',
      'Gas Detection Systems',
      'Emission Monitoring',
      'Calibration Instruments',
      'Process Control Equipment',
    ]
  },
];

export const getAllCategoryNames = (): string[] => {
  return categoriesData.map(cat => cat.name);
};

export const getCategoryByName = (name: string): CategoryData | undefined => {
  return categoriesData.find(cat => cat.name.toLowerCase() === name.toLowerCase());
};

export const searchCategories = (query: string): CategoryData[] => {
  const lowerQuery = query.toLowerCase();
  return categoriesData.filter(
    cat => 
      cat.name.toLowerCase().includes(lowerQuery) ||
      cat.subcategories.some(sub => sub.toLowerCase().includes(lowerQuery))
  );
};
